import Immutable from 'immutable';
import createReducer from '../utils/createreducer';
import {
    LOGIN_USER_REQUEST, LOGIN_USER_SUCCESS, LOGIN_USER_FAILURE, LOGOUT_USER,
    USER_PROFILE_GET_REQUEST, USER_PROFILE_GET_SUCCESS, USER_PROFILE_GET_FAILURE,
    USER_PROFILE_UPDATE_REQUEST, USER_PROFILE_UPDATE_SUCCESS, USER_PROFILE_UPDATE_FAILURE,
    USER_CHANGE_PASSWORD_REQUEST, USER_CHANGE_PASSWORD_SUCCESS, USER_CHANGE_PASSWORD_FAILURE,
    USER_RESET_PASSWORD_REQUEST, USER_RESET_PASSWORD_SUCCESS, USER_RESET_PASSWORD_FAILURE,
    ADMIN_SELECT_USER_ROLE_REQUEST, ADMIN_SELECT_USER_ROLE_SUCCESS, ADMIN_SELECT_USER_ROLE_FAILURE,
    ADMIN_SELECT_DATABASE_REQUEST, ADMIN_SELECT_DATABASE_SUCCESS, ADMIN_SELECT_DATABASE_FAILURE,
    FORCE_AUTH_RECHECK,
} from '../constants/actionconstants';
//import {push} from 'redux-router';
import initialStoreState from '../store/initialstorestate';
import UserRoles from "../../../common/src/enums/UserRoles";

const initialState = initialStoreState.auth;

export default createReducer(initialState, {
    [LOGIN_USER_REQUEST]: (state, payload) => {
        return Object.assign({}, state, {
            isAuthenticating: true,
            statusText: null
        });
    },
    [LOGIN_USER_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            isAuthenticating: false,
            isAuthenticated: true,
            roleId: payload.roleId,
            statusText: 'You have been successfully logged in.',
            // Drupal passport strategy.
            id: payload.id,
            displayName: payload.displayName,
            database: payload.database,
            emails: payload.emails,
            isMainAdmin: payload.isMainAdmin,
            isSectionAdmin: payload.isSectionAdmin,
            isClubAdmin: payload.isClubAdmin,
            clubNumber: payload.clubNumber,
            adminSections: payload.adminSections,
            adminClubs: payload.adminClubs,
            currentRole: payload.currentRole,
            currentEntity: payload.currentEntity,
            // Local passport strategy.
            /*userId: payload.id,
            email: payload.email,
            firstName: payload.firstName,
            lastName: payload.lastName,
            photo: payload.photo,
            photoMimeType: payload.photoMimeType,*/
        });
    },
    [LOGIN_USER_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            isAuthenticating: false,
            isAuthenticated: false,
            roleId: null,
            statusText: `Authentication Error: ${payload.status} ${payload.statusText}`,
            // Drupal passport strategy.
            id: null,
            displayName: null,
            database: 'standard',
            emails: [],
            isMainAdmin: false,
            isSectionAdmin: false,
            isClubAdmin: false,
            clubNumber: null,
            adminSections: null,
            adminClubs: null,
            currentRole: null,
            currentEntity: null,
            // Local passport strategy.
            userId: null,
            email: null,
            firstName: "",  // TODO: Or just copy from initial store state?
            lastName: "",
            photo: null,
            photoMimeType: null,
        });
    },
    [LOGOUT_USER]: (state, payload) => { // This action is also handled in rootreducer.js to clear the state
        return Object.assign({}, state, {
            isAuthenticated: false,
            roleId: null,
            statusText: 'You have been successfully logged out.',
            // Drupal passport strategy.
            id: null,
            displayName: null,
            database: 'standard',
            emails: [],
            isMainAdmin: false,
            isSectionAdmin: false,
            isClubAdmin: false,
            clubNumber: null,
            adminSections: null,
            adminClubs: null,
            currentRole: null,
            currentEntity: null,
            // Local passport strategy.
            userId: null,
            email: null,
            firstName: "",  // TODO: Or just copy from initial store state?
            lastName: "",
            photo: null,
            photoMimeType: null,
        });
    },
    [FORCE_AUTH_RECHECK] : (state, payload) => {
        return Object.assign({}, state, {
            forceAuthRecheck: payload.mustRecheck
        });
    },
    [USER_PROFILE_GET_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
        });
    },
    [USER_PROFILE_GET_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            userId: payload.id,
            email: payload.email,
            roleId: payload.roleId,
            firstName: payload.firstName,
            lastName: payload.lastName,
            photo: payload.photo,
            photoMimeType: payload.photoMimeType,
        });
    },
    [USER_PROFILE_GET_FAILURE] : (state, payload) => {
        return Object.assign({}, state, {
            statusText : payload.statusText,
            status : payload.status
        });
    },
    [USER_PROFILE_UPDATE_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
        });
    },
    [USER_PROFILE_UPDATE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            userId: payload.id,
            email: payload.email,
            roleId: payload.roleId,
            firstName: payload.firstName,
            lastName: payload.lastName,
            photo: payload.photo,
            photoMimeType: payload.photoMimeType,
        });
    },
    [USER_PROFILE_UPDATE_FAILURE] : (state, payload) => {
        return Object.assign({}, state, {
            statusText : payload.statusText,
            status : payload.status
        });
    },
    [USER_CHANGE_PASSWORD_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
        });
    },
    [USER_CHANGE_PASSWORD_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
        });
    },
    [USER_CHANGE_PASSWORD_FAILURE] : (state, payload) => {
        return Object.assign({}, state, {
            statusText : payload.statusText,
            status : payload.status
        });
    },
    [USER_RESET_PASSWORD_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
        });
    },
    [USER_RESET_PASSWORD_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
        });
    },
    [USER_RESET_PASSWORD_FAILURE] : (state, payload) => {
        return Object.assign({}, state, {
            statusText : payload.statusText,
            status : payload.status
        });
    },
    [ADMIN_SELECT_USER_ROLE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            currentRole : payload === "m" ? UserRoles.MAIN_ADMIN.id : payload.substr(0, 1) === "s" ? UserRoles.SECTION_ADMIN.id : payload.substr(0, 1) === "c" ? UserRoles.CLUB_ADMIN.id : null,
            currentEntity : payload === "m" ? null : payload.substr(0, 1) === "s" ? payload.substr(-2) : payload.substr(0, 1) === "c" ? payload.substr(-3) : null,
            database : "standard"
        });
    },
    [ADMIN_SELECT_DATABASE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            database : payload,
        });
    },
});



// WEBPACK FOOTER //
// ./src/client/src/reducers/auth.js